import React from 'react';
import StatCard from '../../../components/admin/dashboard/StatCard';
import RecentPortvilleApplications from '../../../components/admin/dashboard/RecentPortvilleApplications';
import RecentFacilityReservations from '@/components/admin/dashboard/RecentFacilityReservations';
import RecentMoveOutRequests from '../../../components/admin/dashboard/RecentMoveOutRequests';
import RecentCustomerInquiries from '../../../components/admin/dashboard/RecentCustomerInquiries';
import useAdminStats from '../../../hooks/admin/useAdminStats';

const DashboardPage: React.FC = () => {
  const {
    totalUsers, 
    activeUsers, 
    recentPortvilleApplications,
    recentFacilityReservations,
    recentPortvilleStayRequests,
    recentCustomerInquiries,
    isLoading,
    error 
  } = useAdminStats();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-lg">통계 데이터를 불러오는 중...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center text-red-600">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* 통계 카드 영역 */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <StatCard
          title="전체 사용자"
          value={totalUsers}
          description="등록된 총 사용자 수"
        />
        <StatCard
          title="활성 사용자"
          value={activeUsers}
          description="현재 활성화된 사용자 수"
        />
      </div>

      {/* 최근 시설물 예약, 포트빌 신청, 연장/퇴거 신청, 고객문의 영역 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-4 gap-6">
        <div>
          <RecentFacilityReservations reservations={recentFacilityReservations} />
        </div>
        <div>
          <RecentPortvilleApplications applications={recentPortvilleApplications} />
        </div>
        <div>
          <RecentMoveOutRequests requests={recentPortvilleStayRequests} />
        </div>
        <div>
          <RecentCustomerInquiries inquiries={recentCustomerInquiries} />
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
